import { Divider, Flex } from 'antd';
import { useLanguage } from 'hooks/Language/useLanguage';
import React, { useState, useEffect } from 'react';

const CountdownTimer: React.FC<{ duration: number }> = ({
  duration,
}) => {
  const { translate } = useLanguage();
  const [time, setTime] = useState<number>(duration * 60);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div>
      <Divider style={{ margin: '8px' }} />
      <Flex justify="space-between">
        <span className="medium-text">{translate('Duration')}</span>
        <p className="medium-text">{formatTime(time)}</p>
      </Flex>
    </div>
  );
};

export default CountdownTimer;
